module.exports = __webpack_public_path__ + "img/left-arrow.8802e0fd.png";